import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlarmOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"alarm_off"}/>
}
